/* globals window */
const $ = require('jquery');

const menuHeight = $('body').hasClass('admin-bar') ? 100 : 90;

class Header {
  setLogo() {
    const scrollTop = $(window).scrollTop();
    if (scrollTop > menuHeight) {
      $('#logo-container .logo').addClass('logo-bottom');
    } else {
      $('#logo-container .logo').removeClass('logo-bottom');
    }
    if (!$('#logo-container .logo').hasClass('animated')) {
      $('#logo-container .logo').addClass('animated');
    }
  }

  init() {
    $('li.menu-item.menu-item-has-children>a').click(e => e.preventDefault());
    this.setLogo();
    $(window).scroll(() => {
      this.setLogo();
    });
  }
}

export default (() => new Header())();
